module.exports = __webpack_public_path__ + "static/media/02-1.1238ba2c.webp";